import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {t} from "../../Translations";
import Infobull from "../icons/Infobull"
import Configuration from "../../Configuration";
import Arrow from "../icons/Arrow";
//import rimsimg from './rimsimg.png'

/**
 * Class representing an input label.
 */
class Label extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        labelStep4: PropTypes.string,
        htmlFor: PropTypes.string
    };

    render() {
        const {className,labelStep4, htmlFor, children} = this.props;
        const client = ("undefined" !== typeof Configuration.brand && Configuration.brand === "P" ? " ap":"");
        var infobull = <strong>i</strong>;
        if (client.trim()==="ap") infobull = <Infobull className="icon"/>;
        const infobullArrow = client.trim()==="ap" ? <Arrow className="icon icon-arrow-ap"/> :"";
        const lastInfobullArrow = client.trim()==="ap" ? <Arrow className="icon icon-arrow-ap last-arrow-ap"/> :"";
        const labelProps = {
            className: classNames("cccu-label caroussel-digital-one-label digital-one" +client,labelStep4, {[className]: className !== undefined})
        };

        if (htmlFor) {
            labelProps.htmlFor = htmlFor
        }
        // Ajout info bulle
        if (children === (t('Step1_form_gearbox') + "*")) {
            return (
                <label {...labelProps}>{children}&nbsp;&nbsp;
                    <div className={"info-btn"+client}>
                        {infobull}
                        {infobullArrow}
                    </div>
                    <span className={"info-btn-text"+client}>{t('Step1_Gear_info')}</span>
                </label>
            )
        }
        // Ajout info bulle pour le champ véhicule
        if (children === (t('Step1_form_date') + "*")) {
            return (
                <label {...labelProps}>{children}&nbsp;&nbsp;
                    <div className={"info-btn"+client}>
                        {infobull}
                        {infobullArrow}
                    </div>
                    <span className={"info-btn-text"+client}>{t('Step1_form_info')}</span>
                </label>
            )
        }
        // Ajout info bulle pour le champ Rims
        if (children === (t('Step1_form_rims') + "*")) {
            return (
                <label {...labelProps}>{children}&nbsp;&nbsp;
                    <div className={"info-btn"+client}>
                        {infobull}
                        {lastInfobullArrow}
                    </div>
                    <span className={"info-btn-text"+client} >
                    <div>
                            {t('Step1_form1_rims')}
                        {/*<img className="image-car" style={{maxWidth:"100%",width:"-webkit-fill-available"}} src="https://test-fo.consuse.awsmpsa.com/static/media/rimsimg.28671270.png" alt="rims_image" />*/}
                        </div>
                    </span>

                    
                  
                </label>
            )
        }

        // Ajout exposants
        if (children === t('Step2_driving_question_2') || children === t('Step2_driving_question_1') || children === t('Step2_trips_question_1')) {
            return (
                <label {...labelProps}>{children}<sup>(1)</sup></label>
            )
        } else if (children === t('Step2_trips_question_2')) {
            return (
                <label {...labelProps}>{children}<sup>(2)</sup></label>
            )
        } else {
            return (
                <label {...labelProps}>{children}</label>
            )
        }
    }
}

export default Label;



// WEBPACK FOOTER //
// ./src/components/widgets/Label.js